import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from "mobx-react"
import FaIcon from '../../../helpers/fa_icon.js'

@inject("store")
@observer
export default class RemoveFieldInstance extends React.Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    instance: PropTypes.number.isRequired
  }
  
  render() {
    const { store } = this.props

    return (
      <div className="side-controls">
        <span className="control">
          <a style={{cursor: "pointer"}} onClick={() => store.removeInstance(this.props.field.uuid, this.props.instance)}>
            <FaIcon icon="times" />
          </a>
        </span>
      </div>
    )
  }
}
